// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import FreeShippingBannerSection from '../../../molecules/FreeShippingBannerSection';

const FreeShippingBanner = (props) => {
  const { className } = props;
  return (
    <div className={className}>
      <FreeShippingBannerSection />
    </div>
  );
};

FreeShippingBanner.propTypes = {
  className: PropTypes.string,
};

FreeShippingBanner.defaultProps = {
  className: '',
};

export default FreeShippingBanner;
